import { Box, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import DescriptionList from 'components/DescriptionList'
import AdminPracticeDetailContext from 'pages/AdminPracticeDetail/context'
import React from 'react'
import { adminBillingAccountDetailURL } from 'routes/urls'
import PracticeContactInfo from 'components/PracticeContactInfo'

const AdminPracticeProfile: React.FC = () => {
  const { practice } = React.useContext(AdminPracticeDetailContext)

  const billingAccount = React.useMemo(() => {
    if (!practice?.billing_account_id) return 'N/A'
    return (
      <Link component={RouterLink} to={adminBillingAccountDetailURL(practice.billing_account_id)}>
        Billing Account ID: {practice.billing_account_id} ({practice.stripe_customer_id})
      </Link>
    )
  }, [practice?.billing_account_id, practice?.stripe_customer_id])
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <DescriptionList labelWidth='20%' valueWidth='80%' rowGap={1} data={[{
        label: 'ID',
        value: practice.practice_id.toString()
      }, {
        label: 'Practice Name',
        value: practice.practice_name
      }, {
        label: 'Address',
        value: practice.address,
        sx: { whiteSpace: 'pre-line' }
      }, {
        label: 'CQC Location ID',
        value: practice.cqc_location_id || 'N/A'
      }, {
        label: 'Phone Numbers',
        value: <PracticeContactInfo inquiries={practice.phone_for_inquiries} notifications={practice.phone_for_notifications} />
      }, {
        label: 'Emails',
        value: <PracticeContactInfo inquiries={practice.email_for_inquiries} notifications={practice.email_for_notifications} />
      }, {
        label: 'First Member',
        value: practice.first_member_label,
      }, {
        label: 'Sign Up At',
        value: practice.signup_at_label,
      }, {
        label: 'Locumloop Fees (Dental Nurse)',
        value: practice.locumloop_fees_label('dental nurse')
      }, {
        label: 'Locumloop Fees (Hygienist)',
        value: practice.locumloop_fees_label('hygienist')
      }, {
        label: 'Default Bonus Rate - Dental Nurse (£/hr)',
        value: `£${practice.default_dental_nurse_bonus_rate.toFixed(2)}/hr`
      }, {
        label: 'Practice Group',
        value: practice.practice_group_label || 'N/A'
      }, {
        label: 'Affiliate',
        value: practice.affiliate_code || 'N/A',
      }, {
        label: 'Enabled',
        value: practice.enabled ? 'Yes': 'No',
      }, {
        label: 'Ready to process payments',
        value: practice.is_stripe_ready ? 'Yes': practice.not_stripe_ready_reason,
      }, {
        label: 'Billing Account',
        value: billingAccount
      }, {
        label: 'Late Cancellation Policy',
        value: practice.late_cancellation_policy,
      }]} />
    </Box>
  )
}

export default AdminPracticeProfile